function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#57A99A;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M458.16,133.59h48.02c24.2,0,41.41,12.48,41.41,34.6c0,12.48-6.05,23.26-16.26,28.74v0.38 c14.75,4.35,21.74,17.96,21.74,31.57c0,26.85-21.55,38.95-46.32,38.95h-48.59V133.59z M506.18,188.42 c10.59,0,16.64-7.56,16.64-17.21c0-9.64-5.67-16.64-17.02-16.64h-23.26v33.84H506.18z M508.64,246.84 c12.48,0,19.47-8.13,19.47-19.47c0-11.16-7.18-19.28-19.47-19.28h-26.09v38.76H508.64z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M646.28,233.42H599.2l-11.34,34.41h-25.15l47.27-134.24h25.52l47.27,134.24h-25.15L646.28,233.42z  M622.65,156.84c0,0-3.03,13.23-5.67,20.8l-11.91,35.92h35.17l-11.91-35.92c-2.46-7.56-5.29-20.8-5.29-20.8H622.65z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M699.98,133.59H748c24.2,0,41.41,12.48,41.41,34.6c0,12.48-6.05,23.26-16.26,28.74v0.38 c14.75,4.35,21.74,17.96,21.74,31.57c0,26.85-21.55,38.95-46.32,38.95h-48.59V133.59z M748,188.42c10.59,0,16.64-7.56,16.64-17.21 c0-9.64-5.67-16.64-17.02-16.64h-23.26v33.84H748z M750.46,246.84c12.48,0,19.47-8.13,19.47-19.47c0-11.16-7.18-19.28-19.47-19.28 h-26.09v38.76H750.46z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M821.36,133.59h43.3c14.56,0,21.18,1.13,27.04,3.78c13.42,6.05,21.93,18.91,21.93,36.68 c0,16.07-8.51,31.01-22.69,36.68v0.38c0,0,1.89,1.89,4.54,6.62l27.6,50.1h-27.23l-26.66-50.1h-23.44v50.1h-24.39V133.59z  M867.68,196.55c13.05,0,21.18-7.75,21.18-21.18c0-12.86-5.48-20.8-24.58-20.8h-18.53v41.97H867.68z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M945.76,133.59h24.39v134.24h-24.39V133.59z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1047.67,243.06c0,0,13.8,14.56,34.79,14.56c14.56,0,26.47-8.7,26.47-23.07c0-33.47-66.36-24.96-66.36-66.17 c0-19.1,16.83-35.73,41.41-35.73c23.07,0,35.54,12.86,35.54,12.86l-6.43,10.97c0,0-11.72-11.34-29.12-11.34 c-17.02,0-27.98,11.16-27.98,22.88c0,31.57,66.36,22.5,66.36,66.17c0,19.85-15.31,35.92-40.27,35.92 c-27.23,0-42.16-17.02-42.16-17.02L1047.67,243.06z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1210.08,132.64c37.62,0,67.69,29.68,67.69,67.88c0,38.95-30.06,69.58-67.69,69.58 c-37.62,0-67.69-30.63-67.69-69.58C1142.39,162.33,1172.45,132.64,1210.08,132.64z M1210.08,258c29.87,0,54.07-24.96,54.07-57.48 c0-31.76-24.2-55.77-54.07-55.77c-30.06,0-54.07,24.01-54.07,55.77C1156,233.04,1180.02,258,1210.08,258z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1307.26,134.91h69.95v11.72h-56.91v49.91h48.78v11.72h-48.78v59.56h-13.05V134.91z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1434.31,146.63h-47.83v-11.72H1495v11.72h-47.65v121.19h-13.05V146.63z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1583.48,154.39c0,0-2.08,11.34-4.35,19.85l-25.34,93.59h-15.69l-34.41-132.91h13.61l25.71,103.23 c1.7,6.81,3.03,14.18,3.03,14.18h0.38c0.19,0,1.13-7.37,3.03-14.18l27.98-103.23h12.48l27.98,103.23 c1.89,6.81,2.84,14.18,3.03,14.18h0.38c0,0,1.32-7.37,3.03-14.18l26.66-103.23h13.61l-35.36,132.91h-15.69l-25.33-93.59 c-2.27-8.51-4.35-19.85-4.35-19.85H1583.48z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1752.13,225.48h-53.51l-15.13,42.35h-13.8l48.78-132.91h13.99l48.78,132.91h-13.8L1752.13,225.48z  M1725.29,148.71c0,0-2.84,10.97-5.1,17.21l-17.77,48.21h45.75l-17.39-48.21c-2.27-6.24-5.1-17.21-5.1-17.21H1725.29z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1802.99,134.91h39.33c13.61,0,19.66,1.32,24.96,3.59c12.48,5.48,20.04,18.15,20.04,34.22 c0,17.96-10.21,31.76-25.15,35.92v0.38c0,0,1.32,1.7,3.4,5.29l28.93,53.51h-14.94l-30.06-55.96h-33.46v55.96h-13.05V134.91z  M1847.61,200.14c16.07,0,26.28-10.4,26.28-27.04c0-10.97-4.35-19.1-12.1-23.26c-3.97-2.08-8.7-3.21-18.91-3.21h-26.85v53.51 H1847.61z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1921.73,134.91h74.87v11.72h-61.83v48.4h50.48v11.72h-50.48v49.35H2000v11.72h-78.27V134.91z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  y: 33.7,
  className: "st1",
  width: 61.49,
  height: 24.9
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M402.26,304.44l-32.62,0c0.3-7.22,0.78-14.52,0.49-21.88l32.13,0V304.44z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M306.13,304.44v-21.88h63.95c-2.19-34.55-20.21-72.2-64.43-85.68v-1.16c17.6-10.1,30.6-25.73,38.58-43.65 h-11.6v-14.76h16.9c2.67-9.55,4.03-19.47,4.03-29.35C353.58,36.95,295.84,0,213.28,0H61.43v372.01h23.91v17.16H61.43v23.64 h151.85c77.39,0,148.59-29.33,156.34-108.38H306.13z M162.47,86.61h50.23c27.14,0,38.11,16.17,38.11,35.22 c0,19.63-10.97,38.11-36.37,38.11h-51.96V86.61z M108.25,58.59H61.49V33.7h46.77V58.59z M223.09,326.21h-60.62v-85.45h61.2 c29.44,0,43.3,19.05,43.3,42.15C266.97,306,252.54,326.21,223.09,326.21z"
}))));

function SvgBabri(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 412.82",
    style: {
      enableBackground: "new 0 0 2000 412.82"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabri);
export default __webpack_public_path__ + "static/media/babri.300f98f2.svg";
export { ForwardRef as ReactComponent };